import { ComponentOwner } from "../component-owner"

export abstract class GraphicsComponent  {
    abstract owner: ComponentOwner

    abstract addToScene()
    abstract removeFromScene()
    abstract update(delta: number)
}